export interface SGPersona {
    dpi: string;
    appUserId: string;
    nombres: string;
    apellidos: string;
    fechaNacimiento: Date | undefined;
    estadoCivil: string;
    genero: string;
    identidadCultural: string;
    comunidadLinguistica: string;
    nit: string;
    nacionalidad: string;
    numeroPasaporte: string;
    fechaEmisionPasaporte: Date | null;
    paisPasaporte: string;
    reCalleAvenida: string;
    reAptoSimilar: string;
    reNumeroCasa: string;
    reZona: string;
    reColoniaBarrioAldea: string;
    reDepartamento: string;
    reMunicipio: string;
    reApartadoPostal: string;
    telefonoCasa: string;
    celular: string;
    proGradoAcademico: string;
    proProfesionUOficio: string;
    proColegioProfesional: string;
    proNumeroColegiado: string;
    labActividadEconomica: string;
    labEntidad: string;
    labDepartamento: string;
    labMunicipio: string;
    labDependencia: string;
    labPuestoFuncional: string;
    labRenglon: string;
    labEmpresa: string;
    labFechaIngreso: Date | null;
    catDelegacionId: number;
    isUpdatedInfo: boolean;
    isMigratedUser: boolean;
}

export class SGPersona implements SGPersona {
    constructor(init: SGPersonaFormValues) {
        Object.assign(this, init);
    }
}

export class SGPersonaFormValues {
    dpi: string = '';
    appUserId: string = '';
    nombres: string = '';
    apellidos: string = '';
    fechaNacimiento: Date | undefined  = undefined;
    estadoCivil: string = '';
    genero: string = '';
    identidadCultural: string = '';
    comunidadLinguistica: string = '';
    nit: string = '';
    nacionalidad: string = '';
    numeroPasaporte: string = '';
    fechaEmisionPasaporte: Date | null = null;
    paisPasaporte: string = '';
    reCalleAvenida: string = '';
    reAptoSimilar: string = '';
    reNumeroCasa: string = '';
    reZona: string = "1";
    reColoniaBarrioAldea: string = '';
    reDepartamento: string = '';
    reMunicipio: string = '';
    reApartadoPostal: string = '';
    telefonoCasa: string = '';
    celular: string = '';
    proGradoAcademico: string = '';
    proProfesionUOficio: string = '';
    proColegioProfesional: string = '';
    proNumeroColegiado: string = '';
    labActividadEconomica: string = '';
    labEntidad: string = '';
    labDepartamento: string = '';
    labMunicipio: string = '';
    labDependencia: string = '';
    labPuestoFuncional: string =''; 
    labRenglon: string = '';
    labEmpresa: string = '';
    labFechaIngreso: Date | null = null;
    catDelegacionId: number = 0;
    isMigratedUser: boolean = false;
    isUpdatedInfo: boolean = false;
    
    constructor(SGPersona?: SGPersonaFormValues) {
        if (SGPersona) {
            this.dpi = SGPersona.dpi;
            this.appUserId = SGPersona.appUserId || '';
            this.nombres = SGPersona.nombres || '';
            this.apellidos = SGPersona.apellidos || '';
            //this.fechaNacimiento = SGPersona.fechaNacimiento;
            this.fechaNacimiento = SGPersona.fechaNacimiento;
            this.estadoCivil = SGPersona.estadoCivil || '';
            this.genero = SGPersona.genero || '';
            this.identidadCultural = SGPersona.identidadCultural || '';
            this.comunidadLinguistica = SGPersona.comunidadLinguistica || '';
            this.nit = SGPersona.nit || '';
            this.nacionalidad = SGPersona.nacionalidad || '';
            this.numeroPasaporte = SGPersona.numeroPasaporte || '';
            this.fechaEmisionPasaporte = SGPersona.fechaEmisionPasaporte;
            this.paisPasaporte = SGPersona.paisPasaporte || '';
            this.reCalleAvenida = SGPersona.reCalleAvenida || '';
            this.reAptoSimilar = SGPersona.reAptoSimilar || '';
            this.reNumeroCasa = SGPersona.reNumeroCasa || '';
            this.reZona = SGPersona.reZona || "";
            this.reColoniaBarrioAldea = SGPersona.reColoniaBarrioAldea || '';
            this.reDepartamento = SGPersona.reDepartamento || '';
            this.reMunicipio = SGPersona.reMunicipio || '';
            this.reApartadoPostal = SGPersona.reApartadoPostal || '';
            this.telefonoCasa = SGPersona.telefonoCasa || '';
            this.celular = SGPersona.celular || '';
            this.proGradoAcademico = SGPersona.proGradoAcademico || '';
            this.proProfesionUOficio = SGPersona.proProfesionUOficio || '';
            this.proColegioProfesional = SGPersona.proColegioProfesional || '';
            this.proNumeroColegiado = SGPersona.proNumeroColegiado || '';
            this.labActividadEconomica = SGPersona.labActividadEconomica || '';
            this.labEntidad = SGPersona.labEntidad || '';
            this.labDepartamento = SGPersona.labDepartamento || '';
            this.labMunicipio = SGPersona.labMunicipio || '';
            this.labDependencia = SGPersona.labDependencia || '';
            this.labPuestoFuncional = SGPersona.labPuestoFuncional || '';
            this.labRenglon = SGPersona.labRenglon || '';
            this.labEmpresa = SGPersona.labEmpresa || '';
            this.labFechaIngreso = SGPersona.labFechaIngreso;
            this.catDelegacionId = SGPersona.catDelegacionId;
            this.isUpdatedInfo = SGPersona.isUpdatedInfo;
            this.isMigratedUser = SGPersona.isMigratedUser;
        }
            
    }
}

export class Degree {
    id : number = 0
    dpi : string = ''
    name : string = ''
    date : string = ''
    codigo : string = ''
    nameCur : string = ''
    nota : number = 0
    cuc : string = ''
    acta : string = ''
    link_qr : string = ''
    diploma : string = ''
    duracion : string = ''
    horas : number = 0
    mail : string = ''
    dip_registro : string = ''
    tipo_pago : string = ''
    status_pago : string = ''
    portafolio : string = ''
    obser : string = ''
    tipo : string = ''
    cod_generar : string = ''
    estado : number = 0
    link_archivo : string = ''
    ver : number = 0
    statuss : string = ''
    imp : number = 0
    age : number = 0

    constructor (DegreeInstance?: Degree) {
        if (DegreeInstance) {
            this.id = DegreeInstance.id
            this.dpi = DegreeInstance.dpi
            this.name = DegreeInstance.name
            this.date = DegreeInstance.date
            this.codigo = DegreeInstance.codigo
            this.nameCur = DegreeInstance.nameCur
            this.nota = DegreeInstance.nota
            this.cuc = DegreeInstance.cuc
            this.acta = DegreeInstance.acta
            this.link_qr = DegreeInstance.link_qr
            this.diploma = DegreeInstance.diploma
            this.duracion = DegreeInstance.duracion
            this.horas = DegreeInstance.horas
            this.mail = DegreeInstance.mail
            this.dip_registro = DegreeInstance.dip_registro
            this.tipo_pago = DegreeInstance.tipo_pago
            this.status_pago = DegreeInstance.status_pago
            this.portafolio = DegreeInstance.portafolio
            this.obser = DegreeInstance.obser
            this.tipo = DegreeInstance.tipo
            this.cod_generar = DegreeInstance.cod_generar
            this.estado = DegreeInstance.estado
            this.link_archivo = DegreeInstance.link_archivo
            this.ver = DegreeInstance.ver
            this.statuss = DegreeInstance.statuss
            this.imp = DegreeInstance.imp
            this.age = DegreeInstance.age
        }
    }
}